// extracted by mini-css-extract-plugin
export default {"form":"form---ckMlW","footer":"footer---DEflv"};